import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface HolidayReasonViewData {
  dateLabel: string;
  reason: string;
}

@Component({
  selector: 'app-holiday-reason-view-dialog',
  templateUrl: './holiday-reason-view-dialog.component.html',
  styleUrls: ['./holiday-reason-view-dialog.component.scss'],
})
export class HolidayReasonViewDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: HolidayReasonViewData,
    private readonly ref: MatDialogRef<HolidayReasonViewDialogComponent>,
  ) {}

  close(): void {
    this.ref.close();
  }
}
